(() => {
  if (window.SanamSmartSearch) return;
  const configNode = document.getElementById('sanam-search-config');
  if (!configNode || !window.SanamSearchCatalog) return;
  const config = JSON.parse(configNode.textContent);
  const t = config.text;
  const groups = window.SanamSearchCatalog.groups;
  const normalize = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
  const tokenMatch = (text, value) => !!normalize(value) && (` ${normalize(text)} `).includes(` ${normalize(value)} `);
  const slug = value => normalize(value).replace(/ /g, '-');
  const escape = value => String(value ?? '').replace(/[&<>"']/g, char => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[char]));
  const money = cents => new Intl.NumberFormat('es-UY', {style:'currency',currency:'UYU',maximumFractionDigits:0}).format(cents / 100) + ' UYU';
  const safeURL = value => {
    try {
      const url = new URL(value, location.origin);
      return ['http:', 'https:'].includes(url.protocol) ? url.href : '';
    } catch { return ''; }
  };
  const imageURL = (value, width = 160) => {
    const result = safeURL(value);
    if (!result) return '';
    const url = new URL(result);
    url.searchParams.set('width', width);
    return url.href;
  };
  const aliases = {'skz':'Stray Kids','zb1':'ZEROBASEONE','albumes':'álbum','albums':'álbum','album':'álbum','photocards oficiales':'photocards','pc':'photocard','pcs':'photocards'};
  const canonicalQuery = value => aliases[normalize(value)] || value.trim();
  const searchURL = (query, params = {}) => {
    const url = new URL(config.searchUrl, location.origin);
    url.searchParams.set('q', canonicalQuery(query));
    url.searchParams.set('type', 'product');
    url.searchParams.set('options[prefix]', 'last');
    url.searchParams.set('options[unavailable_products]', 'hide');
    for (const [key, value] of Object.entries(params)) if (value) url.searchParams.set(key, value);
    const preview = new URL(location.href).searchParams.get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id', preview);
    return url.href;
  };
  const typeDefinitions = [
    {id:'album',label:t.album,terms:['álbum','album','albumes']},
    {id:'photocard',label:t.photocard,terms:['photocard','photocards','polaroid','polaroids']},
    {id:'coloring',label:t.coloring,terms:['librito','colorear','pintar']},
    {id:'plush',label:t.plush,terms:['peluche','peluches','skzoo','lovelys']},
    {id:'accessory',label:t.accessory,terms:['sleeve','sleeves','holder','holders','folio','folios','toploader','toploaders','binder']},
    {id:'custom',label:t.custom,terms:['personalizado','personalizados','personalizada','personalizadas','bias kit']},
    {id:'poster',label:t.poster,terms:['poster','posters','póster','pósters']}
  ];
  const staticCategories = [
    {name:t.album,query:'álbum',terms:['album','albumes','albums']},
    {name:t.photocard,url:config.rootUrl+'collections/photocards-oficiales',terms:['photocard','photocards','pc','pcs']},
    {name:t.coloring,query:'librito',terms:['librito','libritos','pintar','colorear']},
    {name:t.plush,query:'peluches',terms:['peluche','peluches','skzoo','lovelys']},
    {name:t.accessory,query:'sleeves',terms:['sleeves','toploader','accesorios','holder']},
    {name:t.immediate,url:config.rootUrl+'collections/entrega-inmediata-todos-los-productos',terms:['entrega inmediata']},
    ...['Deportes','Series/Películas','Animes','Juegos','Streamers/Youtubers','Tendencias'].map((name,i)=>({name,url:config.rootUrl+'collections/'+['deportes','series-peliculas','animes','juegos','streamers-youtubers','tendencias'][i],terms:[name]}))
  ];
  function localSuggestions(query) {
    const key = normalize(query);
    const categories = groups.filter(g=>g.aliases.some(a=>normalize(a).startsWith(key))).slice(0,4).map(g=>({title:g.name,url:g.handle?config.rootUrl+'collections/'+g.handle:searchURL(g.name),kind:'category'}));
    for (const category of staticCategories) {
      if (category.terms.some(term=>normalize(term).startsWith(key))) categories.push({title:category.name,url:category.url || searchURL(category.query),kind:'category'});
    }
    const members = [];
    for (const group of groups) {
      for (const member of group.members) {
        if (normalize(member).startsWith(key)) members.push({title:member+' · '+group.name,url:searchURL(member,{ss_group:group.slug,ss_member:member}),kind:'member'});
      }
    }
    return {categories:categories.slice(0,5),members:members.slice(0,4)};
  }
  const predictionCache = new Map();
  function initPredictive(form) {
    if (form.dataset.initialized) return;
    form.dataset.initialized = 'true';
    const input = form.querySelector('[data-smart-input]');
    const panel = form.querySelector('[data-smart-panel]');
    const list = form.querySelector('[data-smart-options]');
    const status = form.querySelector('[data-smart-status]');
    const params = new URL(location.href).searchParams;
    input.value = params.get('ss_query') || params.get('q') || '';
    let timer, controller, sequence = 0, active = -1, composing = false;
    const hide = () => {panel.hidden = true;input.setAttribute('aria-expanded','false');input.removeAttribute('aria-activedescendant');active = -1;};
    const show = () => {panel.hidden = false;input.setAttribute('aria-expanded','true');};
    const optionMarkup = (item, index) => `<a id="ss-option-${index}" class="ss-option${item.kind==='product'?' ss-product-option':''}" role="option" aria-selected="false" href="${escape(safeURL(item.url))}" tabindex="-1">${item.image?`<img src="${escape(imageURL(item.image))}" width="64" height="64" alt="" loading="lazy">`:''}<span>${escape(item.title)}${item.price!=null?`<strong>${escape(money(item.price))}</strong>`:''}${item.fulfillment==='order'?`<small class="sanam-order-badge">${escape(t.by_order)}</small>`:''}</span>${item.kind!=='product'?'<span class="ss-option-arrow" aria-hidden="true">↗</span>':''}</a>`;
    const render = (query, data = {}, failed = false) => {
      const local = query.length ? localSuggestions(query) : {categories:[{title:'BTS',url:searchURL('BTS')},{title:'TWICE',url:searchURL('TWICE')},{title:'Stray Kids',url:searchURL('Stray Kids')},{title:t.album,url:searchURL('álbum')},{title:t.photocard,url:searchURL('photocards')}],members:[]};
      let index = 0, html = '';
      const section = (title, items) => {
        if (!items.length) return;
        html += `<div role="group" aria-label="${escape(title)}"><div class="ss-option-heading" role="presentation">${escape(title)}</div>${items.map(item=>optionMarkup(item,index++)).join('')}</div>`;
      };
      section(query ? t.categories : t.popular, local.categories);
      section(t.members, local.members);
      const seen = new Set(local.categories.map(item=>new URL(item.url,location.origin).pathname));
      const collections = (data.collections || []).filter(item=>!seen.has(new URL(item.url,location.origin).pathname)).slice(0,3);
      if (collections.length) section(t.categories, collections.map(item=>({title:item.title,url:item.url,kind:'category'})));
      const products = (data.products || []).filter(item=>item.available).slice(0,6);
      section(t.products, products.map(item=>({title:item.title,url:item.url,image:item.featured_image?.url || item.image,price:Math.round(Number(item.price)*100),fulfillment:item.fulfillment,kind:'product'})));
      const queries = (data.queries || []).slice(0,2).map(item=>({title:item.text,url:searchURL(item.text)}));
      if (queries.length) section(t.suggestions,queries);
      if (query) html += optionMarkup({title:t.all_results+' “'+query+'”',url:searchURL(query)},index++);
      list.innerHTML = html;
      active = -1;input.removeAttribute('aria-activedescendant');
      status.textContent = failed ? t.error : `${index} ${t.suggestions.toLowerCase()}`;
      if (document.activeElement === input) show();
    };
    const run = async () => {
      const query = input.value.trim();
      const current = ++sequence;
      controller?.abort();
      if (query.length < 2) {render(query);return;}
      render(query);
      status.textContent = t.loading;
      const canonical = canonicalQuery(query);
      if (predictionCache.has(canonical)) {render(query,predictionCache.get(canonical));return;}
      controller = new AbortController();
      const url = new URL(config.suggestUrl.replace(/\/$/,''),location.origin);
      url.search = new URLSearchParams({'section_id':'sanam-search-suggestions','q':canonical,'resources[type]':'product,collection,query','resources[limit]':'6','resources[limit_scope]':'each','resources[options][unavailable_products]':'hide','resources[options][fields]':'title,tag,product_type,variants.title'});
      try {
        const response = await fetch(url,{signal:controller.signal,headers:{Accept:'text/html'}});
        if (!response.ok) throw new Error('search');
        const suggestionDoc = new DOMParser().parseFromString(await response.text(),'text/html');
        const suggestionNode = suggestionDoc.querySelector('[data-sanam-predictive-data]');
        if(!suggestionNode) throw new Error('search-suggestions');
        const data = JSON.parse(suggestionNode.textContent);
        if (current !== sequence) return;
        if (predictionCache.size >= 20) predictionCache.delete(predictionCache.keys().next().value);
        predictionCache.set(canonical,data);render(query,data);
      } catch (error) {if (error.name !== 'AbortError' && current === sequence) render(query,{},true);}
    };
    input.addEventListener('input',()=>{clearTimeout(timer);controller?.abort();++sequence;if (!composing) timer=setTimeout(run,180);});
    input.addEventListener('focus',run);
    input.addEventListener('compositionstart',()=>{composing=true;clearTimeout(timer);});
    input.addEventListener('compositionend',()=>{composing=false;run();});
    input.addEventListener('keydown',event=>{
      if (event.key==='Escape') {controller?.abort();hide();event.preventDefault();return;}
      const options = [...list.querySelectorAll('[role="option"]')];
      if (['ArrowDown','ArrowUp'].includes(event.key)) {
        if (!options.length) return;
        event.preventDefault();show();active=(active+(event.key==='ArrowDown'?1:-1)+options.length)%options.length;
        options.forEach((option,index)=>option.setAttribute('aria-selected',String(index===active)));
        input.setAttribute('aria-activedescendant',options[active].id);options[active].scrollIntoView({block:'nearest'});
      } else if (event.key==='Enter' && !panel.hidden && active>=0) {event.preventDefault();location.assign(options[active].href);}
    });
    form.querySelector('[data-smart-close]').addEventListener('click',()=>{hide();input.focus();hide();});
    document.addEventListener('pointerdown',event=>{if(!form.contains(event.target)){clearTimeout(timer);controller?.abort();hide();}});
    form.addEventListener('focusout',()=>{setTimeout(()=>{if(!form.contains(document.activeElement))hide();},0);});
    form.addEventListener('submit',event=>{if(composing)return;event.preventDefault();location.assign(searchURL(input.value));});
  }
  function classify(product) {
    const collections = product.collections || [];
    const tags = product.tags || [];
    const productGroups = groups.filter(group=>collections.includes(group.handle) || tags.includes('sanam-poca-'+group.slug) || group.aliases.some(alias=>tokenMatch(product.title,alias)));
    let productTypes = typeDefinitions.filter(type=>type.terms.some(term=>tokenMatch(product.title+' '+product.type,term))).map(type=>type.id);
    if(productTypes.some(type=>['album','plush','accessory','coloring'].includes(type))) productTypes=productTypes.filter(type=>type!=='photocard');
    if (!productTypes.length) productTypes.push('other');
    const memberMap = new Map();
    for (const group of productGroups) for (const member of group.members) {
      const nameInTitle = tokenMatch(product.title,member);
      const nameInTag = tags.includes('sanam-poca-member-'+slug(member));
      const variants = product.variants.filter(v=>v.available && (nameInTitle || nameInTag || tokenMatch(v.title,member)));
      if (variants.length) memberMap.set(group.slug+'|'+member,variants);
    }
    for (const tag of tags.filter(tag=>tag.startsWith('sanam-poca-member-') && !/^sanam-poca-member-ot\d+$/i.test(tag))) {
      const name = tag.slice('sanam-poca-member-'.length).split('-').map(word=>word[0]?.toUpperCase()+word.slice(1)).join(' ');
      if (![...memberMap.keys()].some(key=>slug(key.split('|')[1])===slug(name))) for(const group of productGroups) memberMap.set(group.slug+'|'+name,product.variants.filter(v=>v.available));
    }
    return {...product,groups:productGroups.map(g=>g.slug),types:productTypes,members:memberMap,immediate:product.fulfillment==='immediate' || ((product.fulfillment==null || product.fulfillment==='') && collections.includes('entrega-inmediata-todos-los-productos')),index:0};
  }
  function matchProduct(product, filter) {
    if (filter.group && !product.groups.includes(filter.group)) return null;
    if (filter.type && !product.types.includes(filter.type)) return null;
    if (filter.availability==='immediate' && !product.immediate) return null;
    let variants = product.variants.filter(v=>v.available);
    if (filter.member) {
      const matching = [...product.members.entries()].filter(([key])=>(!filter.group || key.startsWith(filter.group+'|')) && slug(key.split('|')[1])===slug(filter.member)).flatMap(([,variants])=>variants);
      const ids = new Set(matching.map(v=>v.id));
      variants=variants.filter(v=>ids.has(v.id));
    }
    variants=variants.filter(v=>(filter.min==='' || v.price>=Number(filter.min)*100) && (filter.max==='' || v.price<=Number(filter.max)*100));
    if (!variants.length) return null;
    const selected = variants.reduce((best,v)=>v.price<best.price?v:best,variants[0]);
    return {...product,selected,price:selected.price};
  }
  function initResults(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized='true';
    const form = root.querySelector('[data-search-filters]');
    const fields = root.querySelector('[data-filter-fields]');
    const grid = root.querySelector('[data-result-grid]');
    const count = root.querySelector('[data-result-count]');
    const loadStatus = root.querySelector('[data-load-status]');
    const more = root.querySelector('[data-result-more]');
    const retry = root.querySelector('[data-load-retry]');
    const url = new URL(location.href);
    const query = root.dataset.query;
    const sort = root.querySelector('[data-result-sort]');
    let products=[],visible=24,filtered=[],ready=false;
    const filterNames=['group','member','type','availability','min','max'];
    const readFilter=()=>Object.fromEntries(filterNames.map(name=>[name,form.elements[name].value]));
    const options=(select,values,first)=>{
      const current=select.value;
      select.replaceChildren(new Option(first,''),...values.map(([value,label])=>new Option(label,value)));
      if([...select.options].some(option=>option.value===current)) select.value=current;
    };
    const fillMembers=()=>{
      const values=new Map();
      for(const product of products) for(const key of product.members.keys()) {
        const [group,member]=key.split('|');
        if(!form.elements.group.value || form.elements.group.value===group) values.set(member,member);
      }
      options(form.elements.member,[...values].sort((a,b)=>a[1].localeCompare(b[1],'es')),t.all_members);
    };
    const updateURL=()=>{
      const current=new URL(location.href);
      for(const [name,value] of Object.entries(readFilter())) {current.searchParams.delete('ss_'+name);if(value)current.searchParams.set('ss_'+name,value);}
      current.searchParams.delete('page');current.searchParams.delete('ss_sort');if(sort.value!=='relevance')current.searchParams.set('ss_sort',sort.value);
      history.replaceState(null,'',current);
    };
    const card=product=>{
      const href=new URL(product.url,location.origin);
      if(form.elements.member.value || form.elements.min.value || form.elements.max.value)href.searchParams.set('variant',product.selected.id);
      const src=form.elements.member.value ? product.selected.image || product.image : product.image || product.selected.image;
      const group=groups.find(group=>group.slug===product.groups[0]);
      const prices=product.variants.filter(v=>v.available).map(v=>v.price);
      const from=!form.elements.member.value && !form.elements.min.value && !form.elements.max.value && new Set(prices).size>1;
      return `<a class="ss-card" href="${escape(href.href)}"><div class="ss-card-image">${src?`<img src="${escape(imageURL(src,600))}" width="600" height="600" alt="${escape(product.title)}" loading="lazy">`:''}${product.immediate?`<span class="ss-badge">${escape(t.immediate)}</span>`:product.fulfillment==='order'?`<span class="sanam-order-badge">${escape(t.by_order)}</span>`:''}</div>${group?`<span class="ss-card-group">${escape(group.name)}</span>`:''}<h2>${escape(product.title)}</h2><p class="ss-card-price">${from?escape(t.from)+' ':''}${escape(money(product.price))}</p></a>`;
    };
    const render=()=>{
      const filter=readFilter();
      form.elements.max.setCustomValidity('');
      if(filter.min!=='' && filter.max!=='' && Number(filter.max)<Number(filter.min)) {form.elements.max.setCustomValidity(t.price_error);form.elements.max.reportValidity();return;}
      filtered=products.map(product=>matchProduct(product,filter)).filter(Boolean);
      if(sort.value==='price-up')filtered.sort((a,b)=>a.price-b.price);
      if(sort.value==='price-down')filtered.sort((a,b)=>b.price-a.price);
      if(sort.value==='name')filtered.sort((a,b)=>a.title.localeCompare(b.title,'es'));
      count.textContent=filtered.length+' '+t.items;
      grid.innerHTML=filtered.length?filtered.slice(0,visible).map(card).join(''):`<div class="ss-empty"><h2>${escape(t.empty)}</h2><p>${escape(t.empty_help)}</p><button type="button" class="ss-clear" data-empty-clear>${escape(t.clear)}</button></div>`;
      grid.querySelector('[data-empty-clear]')?.addEventListener('click',clear);
      more.hidden=filtered.length<=visible;
      updateURL();
    };
    function clear() {form.reset();form.elements.max.setCustomValidity('');fillMembers();visible=24;render();}
    form.addEventListener('submit',event=>{event.preventDefault();visible=24;render();});
    form.elements.group.addEventListener('change',()=>{fillMembers();if(ready){visible=24;render();}});
    for(const name of ['member','type','availability'])form.elements[name].addEventListener('change',()=>{if(ready){visible=24;render();}});
    form.elements.max.addEventListener('input',()=>form.elements.max.setCustomValidity(''));
    form.elements.min.addEventListener('input',()=>form.elements.max.setCustomValidity(''));
    root.querySelector('[data-clear-filters]').addEventListener('click',clear);
    sort.addEventListener('change',()=>{visible=24;render();});
    more.addEventListener('click',()=>{visible+=24;render();});
    root.querySelectorAll('[data-grid-size]').forEach(button=>button.addEventListener('click',()=>{grid.classList.toggle('ss-grid-large',button.dataset.gridSize==='large');root.querySelectorAll('[data-grid-size]').forEach(other=>other.setAttribute('aria-pressed',String(other===button)));}));
    root.querySelector('[data-page-search]').addEventListener('submit',event=>{event.preventDefault();location.assign(searchURL(event.currentTarget.elements.q.value));});
    root.querySelector('[data-query-caption]').textContent=query ? t.for_query+' “'+query+'” · '+t.available_only : t.start_help;
    const load=async()=>{
      if(!query){count.textContent='';loadStatus.textContent='';return;}
      retry.hidden=true;loadStatus.textContent=t.loading_all;
      fields.disabled=true;ready=false;
      const collected=new Map();
      let next=searchURL(query),pages=0;
      try {
        while(next){
          const dataURL=new URL(next,location.origin);
          dataURL.searchParams.set('section_id','sanam-search-data');
          dataURL.searchParams.set('options[unavailable_products]','hide');
          const preview=url.searchParams.get('preview_theme_id');if(preview)dataURL.searchParams.set('preview_theme_id',preview);
          const response=await fetch(dataURL,{headers:{Accept:'text/html'}});
          if(!response.ok)throw new Error('search-data');
          const doc=new DOMParser().parseFromString(await response.text(),'text/html');
          const node=doc.querySelector('[data-sanam-search-data]');if(!node)throw new Error('search-data');
          const data=JSON.parse(node.textContent);
          for(const product of data.products)collected.set(product.id,product);
          next=data.next;pages++;
          count.textContent=collected.size+' '+t.count_loading;
          if(pages>100)throw new Error('search-depth');
        }
        products=[...collected.values()].map(classify);
        products.forEach((product,index)=>product.index=index);
        const availableGroups=new Set(products.flatMap(product=>product.groups));
        options(form.elements.group,groups.filter(group=>availableGroups.has(group.slug)).map(group=>[group.slug,group.name]).sort((a,b)=>a[1].localeCompare(b[1],'es')),t.all_groups);
        const intentQuery=normalize(canonicalQuery(query));
        const intentGroup=groups.find(group=>group.aliases.some(alias=>normalize(alias)===intentQuery));
        const intentMembers=groups.flatMap(group=>group.members.filter(member=>normalize(member)===intentQuery).map(member=>({group:group.slug,member})));
        const requestedGroup=url.searchParams.get('ss_group') || intentGroup?.slug || (intentMembers.length===1 ? intentMembers[0].group : '');
        if(availableGroups.has(requestedGroup))form.elements.group.value=requestedGroup;
        fillMembers();
        const availableTypes=new Set(products.flatMap(product=>product.types));
        options(form.elements.type,[...typeDefinitions,{id:'other',label:t.other}].filter(type=>availableTypes.has(type.id)).map(type=>[type.id,type.label]),t.all_types);
        for(const name of ['member','type','availability','min','max']){
          const intentType=typeDefinitions.find(type=>type.terms.some(term=>normalize(term)===intentQuery));
          const value=url.searchParams.get('ss_'+name) || (name==='member' && intentMembers.length===1 ? intentMembers[0].member : name==='type' ? intentType?.id : '') || '';
          if(['min','max'].includes(name)){if(value!=='' && Number.isFinite(Number(value)) && Number(value)>=0)form.elements[name].value=value;}
          else if([...form.elements[name].options].some(option=>option.value===value))form.elements[name].value=value;
        }
        if([...sort.options].some(option=>option.value===url.searchParams.get('ss_sort')))sort.value=url.searchParams.get('ss_sort');
        fields.disabled=false;ready=true;loadStatus.textContent='';root.querySelector('[data-enhanced-controls]').hidden=false;render();
      } catch {loadStatus.textContent=t.load_error;retry.hidden=false;count.textContent='';}
    };
    retry.addEventListener('click',load);load();
  }
  const init=()=>{document.querySelectorAll('[data-smart-search]').forEach(initPredictive);document.querySelectorAll('[data-smart-results]').forEach(initResults);};
  window.SanamSmartSearch={init,normalize,tokenMatch,classify,matchProduct,canonicalQuery,localSuggestions,searchURL};
  init();document.addEventListener('shopify:section:load',init);
})();

